import { render, staticRenderFns } from "./InputBox3.vue?vue&type=template&id=2544a11e&scoped=true"
import script from "./InputBox3.vue?vue&type=script&lang=js"
export * from "./InputBox3.vue?vue&type=script&lang=js"
import style0 from "./InputBox3.vue?vue&type=style&index=0&id=2544a11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544a11e",
  null
  
)

export default component.exports